import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBGTBrSjelmielQ1l8EAb0oGPi5yYNXjQ8",
  authDomain: "e-store-50812.firebaseapp.com",
  databaseURL: "https://e-store-50812.firebaseio.com",
  projectId: "e-store-50812",
  storageBucket: "e-store-50812.appspot.com",
  messagingSenderId: "564712352116",
  appId: "1:564712352116:web:8e6b94f2548c914acde421",
  measurementId: "G-47F7GP17V9",
});

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
